import React from 'react'
import { Button, Spinner } from 'react-bootstrap'

import './styles.css'

const BtnLoader = ({ onClick, hasOnClick, loading, messageNotLoading, messageLoading, style, variant }) => {
    return (
        <div>
            {!hasOnClick ?
                <Button className={style} variant={variant} type="submit" disabled={loading}>
                    {loading && (
                        <Spinner
                            as="span"
                            animation="border"
                            size="sm"
                            role="status"
                            aria-hidden="true"
                        />
                    )}
                    {loading && <span>{"  " + messageLoading}</span>}
                    {!loading && <span>{messageNotLoading}</span>}
                </Button>
            :
                <Button className={style} variant={variant} type="submit" onClick={onClick} disabled={loading}>
                    {loading && (
                        <Spinner
                            as="span"
                            animation="border"
                            size="sm"
                            role="status"
                            aria-hidden="true"
                        />
                    )}
                    {loading && <span>{"  " + messageLoading}</span>}
                    {!loading && <span>{messageNotLoading}</span>}
                </Button>
            }
        </div>
    )
}

export default BtnLoader;
